import { render, staticRenderFns } from "./ForeignLanguageSection.vue?vue&type=template&id=ffd52af2&"
import script from "./ForeignLanguageSection.vue?vue&type=script&lang=js&"
export * from "./ForeignLanguageSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports